import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import { HeaderPagesService } from '../header-pages.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  dataModel = {
    oldPassword: '',
    password: '',
  };
  retypePassword = '';

  constructor(
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private headerPagesService: HeaderPagesService,
    public sharedService: SharedService,
    private router: Router,
  ) { }

  ngOnInit(): void { 
    this.sharedService.showPopupErrorMessage.emit({error: "", displayError: false});
  }

  ngOnDestroy() {
    this.sharedService.isPopupOpened.emit({ isPopupOpened: false});
    this.sharedService.showPopupErrorMessage.emit({error: "", displayError: false});
    this.sharedService.showErrorMessage.emit({error: "", displayError: false});
  }

  saveClick() {
    this.sharedService.showPopupErrorMessage.emit({error: "", displayError: false});
    let errors = '';
    this.dataModel.oldPassword = this.dataModel.oldPassword.trim();
    this.dataModel.password = this.dataModel.password.trim();

    if (!this.dataModel.oldPassword) {
      errors += 'Please enter old password.<br/>';
    }
    if (!this.dataModel.password) {
      errors += 'Please enter new password.<br/>';
    }

    if (this.dataModel.oldPassword == this.dataModel.password) {
      errors += 'Old password and new password same please enter new password.<br/>';
    }

    if (this.retypePassword != this.dataModel.password) {
      errors += 'New password and retype password not same please enter same password.<br/>';
    }

    if (errors) {
      this.sharedService.showPopupErrorMessage.emit({error: errors, displayError: true});
      return;
    }

    const user = {
      id: this.data.userId,
      oldPassword: '',
      password: '',
    };

    user.oldPassword = this.sharedService.encryptpassword(this.dataModel.oldPassword);
    user.password = this.sharedService.encryptpassword(this.dataModel.password);

    this.headerPagesService.resetPassword(user).subscribe(res => {
      if (res) {
        
        if (window.location.pathname != '/login') {
          this.router.navigate(['/login']);
        }
        this.sharedService.resetAllData();
        this.dialogRef.close(true);
      }
    });

  }

  cancelClick(): void {
    this.dialogRef.close();
  }

}
